export default {
  "content": "<g stroke-width=\"3\"><circle cx=\"10\" cy=\"10\" opacity=\".2\" r=\"8\" stroke=\"#aeb1b5\"/><path d=\"M18 10a8 8 0 00-8-8\" stroke=\"#ff00cb\"/></g>",
  "attrs": {
    "fill": "none",
    "height": "20",
    "viewBox": "0 0 20 20",
    "width": "20",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};